import PhoneNumber from "awesome-phonenumber";
import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import CustomerSummary from "interfaces/CustomerSummary";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import getBaseUrl from "utils/getBaseUrl";
import DataTable from "./../common/DataTable";
import ContentLoading from "components/common/ContentLoading";

interface State {
    data: CustomerSummary[];
    spinner: boolean;
    errorMessage?: string;
}

export default class IndexBqs extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
            errorMessage: undefined,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
        this.deleteCustomer = this.deleteCustomer.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Customers</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <div className="button-group">
                        <Link to="/customers/add" className="button__item">
                            <i className="icon-customers-black"></i>Add Customer
                        </Link>
                    </div>
                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">BQS Customers</h2>
                            <div className="datatable-wrapper">
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/customers/0/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    ref={this.mainDataTableRef}
                                    stateSave={true}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "10%" }}>ID</th>
                                            <th style={{ width: "20%" }}>Customer Name</th>
                                            <th style={{ width: "15%" }}>City</th>
                                            <th style={{ width: "20%" }}>Contact Person</th>
                                            <th style={{ width: "15%" }}>Phone</th>
                                            <th style={{ width: "15%" }}>Email</th>
                                            <th className="arrow-hidden"></th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.id}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.name}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.city}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.contact}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>
                                                            {item.phone &&
                                                                new PhoneNumber(item.phone, "US").getNumber(
                                                                    "national"
                                                                )}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.email}</Link>
                                                    </td>
                                                    <td>
                                                        <Link
                                                            to={"/customers/edit/" + item.id}
                                                            className="btn-edit"
                                                        >
                                                            <i className="icon-edit1"></i>
                                                        </Link>
                                                        <a
                                                            className="btn-delete"
                                                            href="#"
                                                            data-id={item.id}
                                                        >
                                                            <i className="icon-delete1"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        document.title = "BQS Customers - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "name",
            "city",
            "contact",
            "phone",
            "email",
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<CustomerSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    private handleDataTableDraw(dataTable: any) {
        $(dataTable)
            .find("a:not([href='#'])")
            .click((e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable)
            .find(".btn-delete")
            .click((e) => {
                e.preventDefault();

                const id = parseInt($(e.currentTarget).attr("data-id")!, 10);

                const confirmDelete = window.confirm("Are you sure you want to delete this customer?");
                if (confirmDelete) {
                    this.deleteCustomer(id);
                }
            });
    }

    private async deleteCustomer(id: number) {
        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            `customers/${id}`,
            {
                method: "DELETE",
            },
            true
        );
        if (response.ok) {
            this.mainDataTableRef.current!.reload();
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/customers/Index-BQS.tsx